import { COINGLOBAL } from 'app/constants/LOCALKEYS'
import useSWR from 'swr'
import { getPersistData } from '../persist'
// import { getPersistData } from '../persist'

const KEY = COINGLOBAL

let swrData: any = getPersistData(KEY) || 'G'

export function useCoinGlobal(initData?: any, reset?: boolean) {
	const { data, mutate } = useSWR<any>(KEY, async () => {
		if (reset === true) {
			swrData = null
			return null
		}
		if (initData !== undefined) {
			swrData = initData
		}
		return swrData
	})

	return {
		data,
		mutate: (value: any) => {
			swrData = value
			return mutate()
		},
	}
}
